export function trackKlaviyoLogin(userEmail: string) {
  if (typeof (window as any).klaviyo === 'object') {
    (window as any).klaviyo.push(['identify', {
      '$email': userEmail,
    }]);
  }
}
